import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";
import {useTheme} from "@mui/material";

export default (props: BaseThatsMeIconProps) => {
    const theme = useTheme()
    const {size = 24, fill= theme.palette.thatsMe.iconsDefault, ...rest} = props;
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M17.6845 7.56367L11.2472 14.0009L14.4778 17.2315L13.2142 18.4951L9.98361 15.2646L5.76361 19.4846L4.5 18.2209L8.72 14.0009L5.48943 10.7704L6.75305 9.50677L9.98361 12.7373L16.4328 6.28813H11.5333V4.5H19.4726V12.4393H17.6845V7.56367Z"
            fill={fill}/>
    </svg>
}
